/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AnyOftasksidTaskActionContent model module.
 * @module model/AnyOftasksidTaskActionContent
 * @version v0.3
 */
export default class AnyOftasksidTaskActionContent {
  /**
   * Constructs a new <code>AnyOftasksidTaskActionContent</code>.
   * @alias module:model/AnyOftasksidTaskActionContent
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AnyOftasksidTaskActionContent</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AnyOftasksidTaskActionContent} obj Optional instance to populate.
   * @return {module:model/AnyOftasksidTaskActionContent} The populated <code>AnyOftasksidTaskActionContent</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AnyOftasksidTaskActionContent();
    }
    return obj;
  }
}
